export const EvidenceStatusMap = {
    default: 0,
    notStarted: 0,
    submitted: 1,
    approved: 2,
    rejected: 3,
    reopened: 4,
};

export const EvidenceStatuses = {
    NotStarted: {
        value: EvidenceStatusMap.notStarted,
        label: { text: 'Not Started' },
        text: 'Not Started',
        css: '',
    },
    Submitted: {
        value: EvidenceStatusMap.submitted,
        label: { text: 'Submitted' },
        text: 'Submitted',
        css: '',
    },
    Approved: {
        value: EvidenceStatusMap.approved,
        label: { text: 'Approved' },
        text: 'Approved',
        css: '',
    },
    Rejected: {
        value: EvidenceStatusMap.rejected,
        label: { text: 'Rejected' },
        text: 'Rejected',
        css: '',
    },
    Reopened: {
        value: EvidenceStatusMap.reopened,
        label: { text: 'Reopened' },
        text: 'Reopened',
        css: '',
    },
};

export const EvidenceStatusFromId = (id) => {
    if (!id) return EvidenceStatuses.NotStarted;

    return Object.values(EvidenceStatuses).find((x) => x.value == id);
};
